//import { useLocalStorage } from "react-use";
import { asSearchItem } from "../utils/searchResults";
import {useSearchCache} from "../appConfig";
import { useState } from "react";
const KEY = "mugis-template";


/**
 * Hook to find search results
 */
const useSearch = (): any => {
  const [cache, setCache] = [[],[]] //useLocalStorage(KEY);
  let resultVal: any = [];
  
  const tempInitialItems = resultVal.length > 0 ? resultVal : ((useSearchCache && cache && cache.length) ? cache : []); //Disable cache
  const initialItems = tempInitialItems.filter((tempInitialItem) => {
    return tempInitialItem !== undefined && tempInitialItem != null;
  })
  const [searchItems, setSearchItems] = useState(initialItems);
  const [selectedItems, setSelectedItems] = useState([]);
  const [displayedSearchItems] = useState(initialItems);
  const [displayedSelectedItems] = useState([]);
  const initialSearchItemLayerNames = initialItems.map(item => item.LayerName).filter((value, index, self) => self.indexOf(value) === index);
  const [searchItemLayerNames, setSearchItemLayerNames] = useState(initialSearchItemLayerNames);
  const [selectedItemLayerNameItems, setSelectedItemLayerNameItems] = useState("");
  const fetchSearchItems =  (assessorSearchResults: any[]) => {
    if (assessorSearchResults) {
      const results = assessorSearchResults.filter((res: any) => {
        return res.LayerName !== undefined
      });
      const items = results.map(asSearchItem(false));
      const searchItemLayerNameItems = results.map(item => item.LayerName).filter((value, index, self) => self.indexOf(value) === index);
      if (useSearchCache) {
        setCache(items); //have config for this option
      }
      setSearchItems(items);
      setSearchItemLayerNames(searchItemLayerNameItems);
      resultVal = items;
      //nprogress.done();
      return items;
    }
  };
  const fetchSelectedItems =  (assessorSelectionResults: any) => {
    if (assessorSelectionResults) {
      const results = assessorSelectionResults.filter((res: any) => {
        return res.LayerName !== undefined
      });
      const items = results.map(asSearchItem(true));
      const selectedItemLayerNameItems = results.map(item => item.LayerName).filter((value, index, self) => self.indexOf(value) === index);
      //setCache(items);
      setSelectedItems(items);
      setSelectedItemLayerNameItems(selectedItemLayerNameItems);
      //resultVal = items;
      //nprogress.done();
      return items;
    }
  };
  return [searchItems, searchItemLayerNames, displayedSearchItems, selectedItems, selectedItemLayerNameItems, displayedSelectedItems, fetchSearchItems, fetchSelectedItems];
};

export default useSearch;
